const VARIANTS = {
  Trained:    "bg-green-100 text-green-700",
  Pending:    "bg-yellow-100 text-yellow-700",
  Failed:     "bg-red-100 text-red-600",
  Processing: "bg-blue-100 text-blue-700",
};

export default function StatusBadge({ status }) {
  const cls = VARIANTS[status] || "bg-gray-100 text-gray-600";
  return (
    <span className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded ${cls}`}>
      ● {status}
    </span>
  );
}
